import { FC } from 'react'
import { Box, Stack, Typography, useTheme } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';


export const SafeCard:FC = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.green[50],
        p: 2,
        borderRadius: 2,
        color: theme.palette.green[800],
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" mb={1}>
        <CheckCircleOutlineIcon sx={{ color: theme.palette.green[800], fontSize: '1.3rem' }} />
        <Typography fontWeight={theme.typography.fontWeightBold} fontSize="1rem" mb={1}>
          Safe
        </Typography>
      </Stack>

      <Typography fontWeight={theme.typography.fontWeightMedium} fontSize="0.9rem">
        Your reading is firmly in the safe zone for this attribute
      </Typography>
    </Box>
  )
}